(() => {
  const T = document.documentElement.lang === 'es'
    ? {h: 'Gracias por su interés', p: 'Andrés o Nathalia te confirmarán por correo el total y el siguiente paso.', ok: 'Aceptar'}
    : {h: 'Thank you for your interest', p: 'Andrés or Nathalia will confirm the total and the next step by email.', ok: 'OK'};
  const thanks = () => {
    let d = document.getElementById('CosmicThanks');
    if (!d) {
      d = document.createElement('dialog');
      d.id = 'CosmicThanks';
      d.className = 'cosmic-purchase-dialog';
      d.setAttribute('aria-labelledby', 'CosmicThanksTitle');
      d.innerHTML = '<div class="cosmic-dialog-inner"><h2 id="CosmicThanksTitle"></h2><p></p><p><button type="button" class="btn" data-ok></button></p></div>';
      d.querySelector('h2').textContent = T.h;
      d.querySelector('p').textContent = T.p;
      d.querySelector('[data-ok]').textContent = T.ok;
      d.querySelector('[data-ok]').addEventListener('click', () => d.close());
      document.body.appendChild(d);
    }
    if (!d.open) d.showModal();
    d.querySelector('[data-ok]').focus();
  };
  const showThanksIfPosted = () => {
    const url = new URL(location.href);
    const posted = url.searchParams.get('contact_posted') === 'true' && !url.searchParams.get('cosmic_registration');
    if (!posted || !document.getElementById('CosmicArtworkForm')) return;
    url.searchParams.delete('contact_posted');
    try { history.replaceState(null, '', url.pathname + url.search); } catch {}
    try { sessionStorage.removeItem('cosmic_pending_form'); } catch {}
    thanks();
  };
  const bind = () => {
    document.querySelectorAll('[data-cosmic-open]').forEach(link => {
      if (link.dataset.purchaseBound) return;
      link.dataset.purchaseBound = 'true';
      link.addEventListener('click', event => {
        const dialog = document.getElementById(link.dataset.cosmicOpen);
        if (!dialog?.showModal) return;
        event.preventDefault();
        const question = link.dataset.cosmicIntent === 'question';
        const select = dialog.querySelector('[data-cosmic-request-type]');
        if (select) select.value = question ? 'Artwork question' : 'Start purchase';
        const heading = dialog.querySelector('h2');
        if (heading?.dataset.purchaseTitle) heading.textContent = question ? heading.dataset.questionTitle : heading.dataset.purchaseTitle;
        dialog.showModal();
        if (question) { const details = dialog.querySelector('details'); if (details) details.open = true; dialog.querySelector('[data-cosmic-question]')?.focus(); }
      });
    });
    document.querySelectorAll('[data-cosmic-dialog]').forEach(dialog => {
      if (dialog.dataset.purchaseBound) return;
      dialog.dataset.purchaseBound = 'true';
      dialog.querySelector('[data-cosmic-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.querySelector('form')?.addEventListener('submit', event => {
        if (!event.target.checkValidity()) return;
        try { sessionStorage.setItem('cosmic_pending_form', JSON.stringify({id: event.target.id, dialog: dialog.id, path: location.pathname})); } catch {}
      });
    });
    document.querySelectorAll('select[name="contact[country]"]').forEach(select => {
      for (const option of select.options) if (option.value === '---') option.remove();
    });
    showThanksIfPosted();
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem('cosmic_pending_form')); } catch {}
    if (pending?.path === location.pathname) {
      const form = document.getElementById(pending.id);
      if (form?.querySelector('[data-cosmic-enquiry-success]')) {
        thanks();
        try { sessionStorage.removeItem('cosmic_pending_form'); } catch {}
      } else if (form?.querySelector('.errors')) {
        const dialog = document.getElementById(pending.dialog);
        if (dialog && !dialog.open) dialog.showModal();
        try { sessionStorage.removeItem('cosmic_pending_form'); } catch {}
      }
    }
    const welcome = document.querySelector('[data-cosmic-welcome]');
    if (!welcome || welcome.dataset.bound) return;
    welcome.dataset.bound = 'true';
    const form = welcome.querySelector('form');
    const key = 'cosmic_welcome_pending';
    let registration;
    try { registration = JSON.parse(sessionStorage.getItem(key)); } catch {}
    const result = welcome.querySelector('[data-welcome-success]');
    const submittedCode = new URL(location.href).searchParams.get('cosmic_registration');
    if (result && registration?.path === location.pathname && submittedCode === registration.code && /^CAG10-[A-F0-9]{32}$/.test(registration.code) && Date.now() - registration.at < 86400000) {
      const output = welcome.querySelector('[data-welcome-code]');
      output.textContent = registration.code;
      output.hidden = false;
      result.hidden = false;
      welcome.querySelector('[data-welcome-retrieve]').hidden = true;
    }
    form?.addEventListener('submit', event => {
      if (!form.checkValidity()) return;
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      const code = 'CAG10-' + Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('').toUpperCase();
      const returnTo = new URL(location.href);
      returnTo.searchParams.delete('contact_posted');
      returnTo.searchParams.set('cosmic_registration', code);
      const returnInput = form.querySelector('[name="return_to"]');
      if (returnInput) returnInput.value = returnTo.pathname + returnTo.search;
      form.querySelector('[name="contact[Registration code]"]').value = code;
      form.querySelector('[name="contact[body]"]').value = 'First artwork registration | ' + code + ' | 10% on one artwork in the first purchase; manual validation required. Newsletter consent: yes.';
      try { sessionStorage.setItem(key, JSON.stringify({code, path: location.pathname, at: Date.now()})); } catch {}
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
